/**
 * The sign-in window tells the panel it is done (ADR-0004 §2.4): `BroadcastChannel('gasbi-ai')` reaches every page of
 * the chat's origin, `window.opener.postMessage` is the fallback (no BroadcastChannel, or only the opener listening).
 */
export const CHANNEL_NAME = 'gasbi-ai';
export const SIGNED_IN_MESSAGE = 'gasbi-ai:signed-in';

const isSignedInMessage = (data: unknown) =>
  (data as { type?: unknown } | null)?.type === SIGNED_IN_MESSAGE;

/** `/auth/done`: tells every listening page of this origin that the user has signed in. */
export const announceSignedIn = () => {
  const message = { type: SIGNED_IN_MESSAGE };
  if (typeof BroadcastChannel !== 'undefined') {
    // A message already posted is delivered after its sender closes.
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(message);
    channel.close();
  }
  window.opener?.postMessage(message, window.location.origin);
};

/** Calls `onSignedIn` for every sign-in signal; returns the unsubscribe. */
export const listenSignedIn = (onSignedIn: () => void) => {
  const onWindowMessage = (event: MessageEvent) => {
    if (
      event.origin === window.location.origin &&
      isSignedInMessage(event.data)
    ) {
      onSignedIn();
    }
  };
  const onChannelMessage = (event: MessageEvent) => {
    if (isSignedInMessage(event.data)) onSignedIn();
  };

  window.addEventListener('message', onWindowMessage);
  const channel =
    typeof BroadcastChannel === 'undefined'
      ? null
      : new BroadcastChannel(CHANNEL_NAME);
  channel?.addEventListener('message', onChannelMessage);

  return () => {
    window.removeEventListener('message', onWindowMessage);
    channel?.close();
  };
};
